import client from "./client";

const getChargebackDetails = (id) => client.get(`chargeback/detail/${id}`);

export default { getChargebackDetails };
